import { collection, getCountFromServer, query } from "firebase/firestore";
import { firestore } from "../../config/firebase";

const getRegistrationPromoUsageCount = async() => {
    const registrationPromoUsageCollection = collection(firestore, "registrationPromosUsage");
    const q = query(registrationPromoUsageCollection)
    const snapshot = await getCountFromServer(q);
    return snapshot.data().count;
}

export default getRegistrationPromoUsageCount;